import React, { useState } from "react";
import { toggleCommentLike } from "../../api/ideas";

function HeartIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
    </svg>
  );
}

/**
 * Один комментарий. Лайк toggle через optimistic update +
 * откат при ошибке.
 */
export default function IdeaCommentItem({ comment, canAct, onError }) {
  const [c, setC] = useState(comment);
  const [busy, setBusy] = useState(false);

  const handleLike = async () => {
    if (!canAct || busy) return;
    setBusy(true);
    const prev = { is_liked: c.is_liked, likes: c.likes };
    setC({ ...c, is_liked: !c.is_liked, likes: c.likes + (c.is_liked ? -1 : 1) });
    try {
      const res = await toggleCommentLike(c.id);
      setC({ ...c, is_liked: res.liked, likes: res.likes });
    } catch (e) {
      setC({ ...c, ...prev });
      onError?.(e.message);
    } finally {
      setBusy(false);
    }
  };

  if (c.hidden) {
    return (
      <div className="idz-comment is-hidden">
        <div className="idz-comment-text">
          <em>Комментарий скрыт модератором{c.hidden_reason ? `: ${c.hidden_reason}` : ""}</em>
        </div>
      </div>
    );
  }

  return (
    <div className="idz-comment">
      <div className="idz-comment-head">
        <span className="idz-comment-author">
          {c.author_name || `#${c.author_id}`}
        </span>
        <span className="idz-comment-time">{formatTime(c.created_at)}</span>
      </div>
      <div className="idz-comment-text">{c.text}</div>
      <div className="idz-comment-actions">
        <button
          type="button"
          className={c.is_liked ? "is-liked" : ""}
          onClick={handleLike}
          disabled={!canAct || busy}
          title={!canAct ? "Войди и подтверди email, чтобы лайкать" : ""}
        >
          <HeartIcon /> {c.likes}
        </button>
      </div>
    </div>
  );
}

function formatTime(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    const now = new Date();
    const diff = (now - d) / 1000;
    if (diff < 60) return "только что";
    if (diff < 3600) return `${Math.floor(diff / 60)} мин назад`;
    if (diff < 86400) return `${Math.floor(diff / 3600)} ч назад`;
    return d.toLocaleDateString("ru-RU");
  } catch {
    return iso;
  }
}
